import styled from 'styled-components'

export const ViewShareWrap = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 1.5em;
    overflow: auto;
`



// WEBPACK FOOTER //
// ./src/pages/ViewShare.styles.js